import { AxiosResponse } from "axios";
import { axiosInstance } from "../AxiosInterceptor";

import * as ApiUrls from './ApiUrl.DataLookup';
import { DataLookupDto } from "../../Model/Dto/StaticData";

export const DataLookupService = {
    GetUsersInRegistrationList: (): Promise<AxiosResponse<DataLookupDto[]>> => axiosInstance.get(ApiUrls.GetUsersInRegistrationList)
}